import { Button, ButtonRow, Card, Collection, CollectionItem, Heading, Text } from '@ksyos/design-system';
import type { IAltoStepProps } from '../../NewAltoDermaOthProcedure';
import type { IRegularStepProps } from '../../NewDermaOthProcedure';
import { StyledImg } from '../../../../elements/atoms/styledImg/StyledImg';
import { CustomContainer } from '../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';

export function Intro(props: (IRegularStepProps | IAltoStepProps) & { altoFlow?: boolean }) {
    return (
        <>
            <CustomContainer>
                <Stack>
                    <Heading
                        mb={2}
                        size="xlarge"
                        style={{ color: 'var(--kds-color-magenta-700)' }}
                    >
                        Welkom! &#128075;
                    </Heading>
                    <Heading
                        as="h2"
                        size="xlarge"
                    >
                        Thuisconsult
                    </Heading>
                </Stack>
                <Stack>
                    <StyledImg
                        alt="derma intro"
                        src="/assets/images/derma-oth/derma-intro.jpg"
                        srcSet="/assets/images/derma-oth/derma-intro.jpg 1x, /assets/images/derma-oth/derma-intro@x2.jpg 2x, /assets/images/derma-oth/derma-intro@x3.jpg 3x,"
                    />
                </Stack>
                <Stack>
                    <Text>
                        Je huisarts ontvangt graag een aantal foto’s van {props.altoFlow ? 'de' : 'je'} klacht. Daarna
                        stellen we je nog een paar vragen.
                    </Text>
                </Stack>
                <Stack>
                    <Card>
                        <Collection>
                            <CollectionItem
                                mediaItem={
                                    <img
                                        alt="Tip"
                                        src="/assets/images/derma-oth/lightbulb.svg"
                                        style={{ width: '54px' }}
                                    />
                                }
                                subtitle="Gebruik je smartphone of tablet!"
                                title="Tip"
                            />
                        </Collection>
                    </Card>
                </Stack>
                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Start vragenlijst
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
